import React from 'react';
import { useMutation } from '@apollo/client';
import Dialog from '@mui/material/Dialog';
import PropTypes from 'prop-types';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

import { CAN_EDIT_TEAM_MEMBERS } from '../../constants/permissions';
import { REMOVE_ASSIGN } from '../../apis/member';
import Button from '../atoms/button';
import useLoader from '../../context/LoaderContext';
import useProjectVersionHistory from '../../context/VersionHistoryContext';
import useWorkspace from '../../context/WorkspaceContext';

const propTypes = {
  tableId: PropTypes.string,
  getTeamMembers: PropTypes.func,
  name: PropTypes.string,
  skillName: PropTypes.string,
  projectId: PropTypes.string,
};
const defaultProps = {
  tableId: '',
  getTeamMembers: () => {},
  name: '',
  skillName: '',
};
const RemoveAssignment = ({ tableId, getTeamMembers, name, skillName, projectId }) => {
  const { setIsLoading } = useLoader();
  const [open, setOpen] = React.useState(false);
  const [updateProjectSkillUser] = useMutation(REMOVE_ASSIGN);
  const { userPermissions } = useWorkspace();
  const {
    undoEdits,
    setUndoEdits,
    selectedListItem,
    showVersionHistoryBar,
    readOnlyMode,
  } = useProjectVersionHistory();
  const permissions = [];
  if (userPermissions !== undefined) {
    if (userPermissions.permissions !== undefined) {
      userPermissions.permissions.map((x) => permissions.push(x));
    }
  }
  const deleteButton = async () => {
    setOpen(true);
  };
  const handleClickOpen = async () => {
    if (!undoEdits) setUndoEdits(true);
    setIsLoading(true);
    setOpen(false);
    const variables = {
      input: {
        id: parseInt(tableId, 10),
        projectId: parseInt(projectId, 10),
      },
    };
    await updateProjectSkillUser({
      variables,
    });
    getTeamMembers();
  };
  const handleClose = () => {
    setOpen(false);
  };

  const isHidden =
    showVersionHistoryBar &&
    readOnlyMode &&
    selectedListItem !== null &&
    selectedListItem !== undefined;

  return (
    <div>
      {permissions.includes(CAN_EDIT_TEAM_MEMBERS) && (
        <Button
          disabled={isHidden}
          className="remove-member-list"
          onClick={deleteButton}
          style={{ marginLeft: 3 }}
        >
          Remove
        </Button>
      )}
      <Dialog
        className="custom-modal-dialog confirmation-modal-dialog"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className="dialog-content">
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to remove ${name} as a ${skillName} ?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions">
          <Button primary outlined onClick={handleClose}>Cancel</Button>
          <Button danger onClick={handleClickOpen} autoFocus>Remove</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
RemoveAssignment.propTypes = propTypes;
RemoveAssignment.defaultProps = defaultProps;
export default RemoveAssignment;
